export const parseNumber = ( num, isFloat, min ) => {
	if ( isFloat )
	{
		return parseFloat( num );
	}
	
	const result = String( num );
	
	result.replace( /\D/gu, '' );

	if ( min )
	{
		return Math.floor( result );
	}

	return Math.ceil( result );
};
